import { render, staticRenderFns } from "./MaleSVG.vue?vue&type=template&id=f33bb40a&scoped=true&"
import script from "./MaleSVG.vue?vue&type=script&lang=js&"
export * from "./MaleSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33bb40a",
  null
  
)

export default component.exports